import {PLATFORMS} from '../../../common/constants/constants';

const PRODUCT_IMAGE_SIZES = {
  [PLATFORMS.DESKTOP]: {
    width: 252,
    height: 224,
  },
  [PLATFORMS.MOBILE]: {
    width: 114,
    height: 114,
  },
};

export {
  PRODUCT_IMAGE_SIZES
}



// WEBPACK FOOTER //
// ./src/view/productSummaryBoxes/pastOpportunitiesProductSummaryBox/pastOpportunitiesProductSummaryBoxConstants.js